import { createTheme } from '@mui/material';

// Create a theme instance using the Tailwind color palette
export const theme = createTheme({
  palette: {
    primary: {
      main: '#5D5DF7', // From Tailwind primary.DEFAULT
      light: '#7979FF', // From Tailwind primary.400
      dark: '#3737D3', // From Tailwind primary.700
      50: '#EEEEFF',
      100: '#DEDEFF',
      200: '#BCBCFF',
      300: '#9B9BFF',
      400: '#7979FF',
      500: '#5D5DF7',
      600: '#4A4AE5',
      700: '#3737D3',
      800: '#2424C1',
      900: '#1111AF',
    },
    secondary: {
      main: '#CEE7F0', // From Tailwind secondary.DEFAULT
      light: '#EEF7FA', // From Tailwind secondary.100
      dark: '#5FB7D2', // From Tailwind secondary.600
      50: '#F7FBFD',
      100: '#EEF7FA',
      200: '#DEF0F6',
      300: '#CEE7F0',
      400: '#A9D7E6',
      500: '#84C7DC',
      600: '#5FB7D2',
      700: '#3AA7C8',
      800: '#2889A7',
      900: '#1F6B83',
    },
    grey: {
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Source Sans Pro", "Helvetica", "Arial", sans-serif', // Using the font from Tailwind config
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  components: {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: '#e0e0e0',
          borderTopWidth: 1,
          minWidth: '50px',
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: '#bdbdbd', // Inactive color
          '&.Mui-active': {
            color: '#5D5DF7', // Primary color from Tailwind
          },
          '&.Mui-completed': {
            color: '#5D5DF7', // Primary color from Tailwind
          },
        },
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          padding: '16px 0',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});
